import * as React from "react";
import Container from "@mui/material/Container";
import mapAndVenues from "../../images/assets/WEB_MAP_AND_FULL_PROGRAMME_COMPRESSED.png";
import { Typography } from "@mui/material";

function MapAndVenues() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content map-content">
        <div className="downloads">
          <div  className="text-section">
            <Typography className="title" variant="h6">
              <a
                href="/downloads/map-and-venues.png"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click to view Map + Venues
              </a>
            </Typography>
            <Typography className="title" variant="h6">
              <a href="/downloads/map-and-venues.png" download>
                ↓ Click to download Map + Venues
              </a>
            </Typography>
          </div>

          <div className="download">
            <Typography className="title" variant="h6">
              <a
                href="/downloads/full-programme.png"
                target="_blank"
                rel="noopener noreferrer"
              >
                Click to view Full Programme
              </a>
            </Typography>
            <Typography className="title" variant="h6">
              <a href="/downloads/full-programme.png" download>
                ↓ Click to download Full Programme
              </a>
            </Typography>
          </div>
        </div>
        <img
          src={mapAndVenues}
          className="map-and-venues-image"
          alt="map-and-venues"
        />
      </div>
    </Container>
  );
}
export default MapAndVenues;
